import { useErrorToast } from "components/toast/ToastComponet";
import {
  FindAllCitysFilterFunction,
  FindCitysByClientsFunction,
  FindClientsMapFunction,
} from "functions/Mapa";
import type {
  FindMapParms,
  ResponseAllCitysFilterTypes,
  ResponseFindClientsByCity,
  ResponseFindMapTypes,
} from "types/mapTypes";

export function useMap() {
  const toast = useErrorToast();

  const findClientsMap = async (
    parms: FindMapParms
  ): Promise<ResponseFindMapTypes[]> => {
    try {
      const resp: ResponseFindMapTypes[] = await FindClientsMapFunction(parms);
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findCityFilter = async (): Promise<ResponseAllCitysFilterTypes[]> => {
    try {
      const resp: ResponseAllCitysFilterTypes[] =
        await FindAllCitysFilterFunction();
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findCitysClients = async (): Promise<ResponseFindClientsByCity> => {
    try {
      const resp: ResponseFindClientsByCity =
        await FindCitysByClientsFunction();
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  return { findClientsMap, findCityFilter, findCitysClients };
}
